// extracted by mini-css-extract-plugin
export default {"svgContainer":"SvgContainer1_svgContainer__u2d5h","outermost":"SvgContainer1_outermost__7dC4s","middle":"SvgContainer1_middle__toV-2","innermost":"SvgContainer1_innermost__sdk6W"};